import React from "react";
import values from "../../values";
import Context from "../../context";
import { Components } from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";
import Cookies from "js-cookie";
import constants from "../../values/constants";

const DriverScreen = () => {
  const { requestDriver, setRequestDriver, resultDriver } = React.useContext(
    Context.DriverScreen
  );

  return (
    <CustomView.Container id="driver-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          <Components.Create />

          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={values.tableHeaders.DRIVER_HEADERS} />
          {resultDriver?.status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={resultDriver?.data?.result?.docs} />
          )}
        </table>
      </div>
      {resultDriver?.status === "success" &&
        resultDriver?.data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestDriver?.page}
              totalPages={resultDriver?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestDriver!({ ...requestDriver, page })
              }
            />
          </div>
        )}
      <Components.Update />
      <Components.Delete />
    </CustomView.Container>
  );
};

export default DriverScreen;
